module.exports = __webpack_public_path__ + "static/media/address.ab1d133c.svg";